<template>
    <hts-router-drawer
        :title="$t('labels.quoteDetail')"
        :size="90"
        :page-tabs="pageTabs?.quote || []"
        is-close
        @loaded="getData">
        <div
            class="flex flex-col"
            :style="{ minWidth: minWidthScroll }">
            <ViewInformation :data-create-quote="dataQuote" />
            <div class="flex space-x-1 justify-end">
                <hts-form-button
                    v-if="checkPermission(layoutPermissions.quote_management)"
                    color="main"
                    icon-name="hi-inbox-arrow-down-icon"
                    icon-position="left"
                    type="button"
                    :disabled="CDisabled"
                    :loading="loadingSendEmail"
                    @click="sendEmail">
                    {{ $t('labels.send2') }}
                </hts-form-button>
                <hts-form-button
                    v-if="checkPermission(layoutPermissions.quote_management)"
                    color="main"
                    icon-name="hi-arrow-down-tray-icon"
                    icon-position="left"
                    type="button"
                    :loading="loadingDownLoadXlsx"
                    :disabled="CDisabled"
                    @click="downloadQuoteXlsx">
                    {{ $t('labels.downloadXlsx') }}
                </hts-form-button>
                <hts-form-button
                    v-if="checkPermission(layoutPermissions.quote_management)"
                    color="main"
                    icon-name="hi-arrow-down-tray-icon"
                    icon-position="left"
                    type="button"
                    :loading="loadingDownLoadPdf"
                    :disabled="CDisabled"
                    @click="downloadQuotePdf">
                    {{ $t('labels.downloadPdf') }}
                </hts-form-button>
            </div>

            <hts-ui-tabs
                v-model="tab"
                :tabs="tabs" />

            <div v-if="tab === 'quote'">
                <view-quote-price
                    :data-create-quote="dataQuote"
                    :only-view="true" />
            </div>
            <div v-if="tab === 'quote-price-information'">
                <data-table-price
                    ref="dataTablePrice"
                    :data-quote="dataQuote"
                    @getData="getData"
                    @refreshTables="refreshTables" />
            </div>
            <div v-if="tab === 'quote-request'">
                <hts-card :title="$t('labels.customer')">
                    <div class="grid gap-x-2 grid-cols-4">
                        <hts-select-cooperator
                            v-model="dataQuote.cooperatorDetail.name"
                            v-model:name="dataQuote.cooperatorDetail.name"
                            :label="$t('labels.customer')"
                            type-cooperator="CUSTOMER"
                            :creatable="true"
                            readonly
                            prop="customer"
                            name-select="customer" />
                        <hts-select-cooperator-contact
                            v-model="dataQuote.contactDetail.fullName"
                            v-model:name="dataQuote.contactDetail.fullName"
                            readonly
                            :label="$t('labels.contact')"
                            prop="contact"
                            name-select="contact" />
                        <hts-form-input
                            v-model="dataQuote.contactDetail.email"
                            :label="$t('labels.email')"
                            readonly />
                        <hts-form-input
                            v-model="dataQuote.contactDetail.phone"
                            :label="$t('labels.phone')"
                            readonly />
                    </div>
                </hts-card>
                <hts-card :title="$t('labels.shippingInformation')">
                    <div class="grid gap-x-2 grid-cols-2">
                        <hts-form-input
                            v-model="dataQuote.businessOpportunityName"
                            :label="$t('labels.businessOpportunity')"
                            readonly />
                        <hts-form-input
                            v-model="dataQuote.commodityName"
                            :label="$t('labels.commodity')"
                            readonly />
                    </div>
                    <hts-form-input
                        v-model="dataQuote.workflowName"
                        :label="$t('labels.workflow')"
                        readonly />
                    <ul
                        v-if="dataQuote.positions && dataQuote.positions.length"
                        class="steps steps-vertical w-full">
                        <li
                            v-for="(item, index) in dataQuote.positions"
                            :key="index"
                            data-content=" "
                            class="pl-10 step w-full">
                            <div class="flex items-center justify-center w-full">
                                <span class="w-52 flex justify-start">
                                    {{ item.nodeTypeName }}
                                </span>
                                <div class="flex items-center w-full gap-5">
                                    <hts-form-input
                                        v-model="item.fullNameNode"
                                        class="w-full"
                                        readonly />

                                    <hts-form-button
                                        icon-name="hi-eye-icon"
                                        size="small"
                                        class="w-96"
                                        color="info"
                                        @click="() => openWorkflowPosition(item)">
                                        {{ $t('labels.viewTaskInfo') }}
                                    </hts-form-button>
                                </div>
                            </div>
                        </li>
                        <!--
                          <div class="text-right">
                          <span
                          class="right-20 text-lg text-blue-600 cursor-pointer italic"
                          @click="openWithMap">
                          {{ $t('labels.openWithMap') }}
                          </span>
                          </div>
                        -->
                    </ul>

                    <hts-form-button
                        v-if="dataQuote.positions && dataQuote.positions.length"
                        icon-name="hi-plus-circle-icon"
                        class="text-right mt-5 w-48"
                        color="info"
                        :btn-outline="false"
                        type="button"
                        @click="handleFindRoutingConnection">
                        Xem trái tuyến
                    </hts-form-button>

                    <div>
                        <div v-if="dataQuote.transportation === 'CONTAINER'">
                            <hts-form-input
                                v-model="dataQuote.contName"
                                :label="$t('labels.cont')"
                                readonly />
                            <span>
                                {{ $t('labels.requestSpecial') }}
                            </span>
                            <div class="flex">
                                <hts-form-checkbox
                                    v-if="dataQuote.contCategory === 20"
                                    v-model="dataQuote.mergeContainer"
                                    color="secondary"
                                    readonly
                                    :items="[{ label: $t('labels.mergeContainer'), value: false }]" />
                                <hts-form-checkbox
                                    v-model="dataQuote.headContainer"
                                    color="secondary"
                                    readonly
                                    :items="[{ label: $t('labels.headContainer'), value: false }]" />
                            </div>
                        </div>
                        <div v-else-if="dataQuote.transportation === 'NON_CONTAINER'">
                            <hts-form-input
                                v-model="dataQuote.vehicleCategoryName"
                                :label="$t('labels.vehicleType')"
                                readonly />
                        </div>
                        <hts-form-input
                            v-model="dataQuote.productivity"
                            :label="$t('labels.productivityByMount')"
                            type="number"
                            readonly
                            prop="productivity"
                            name="productivity">
                            <template #suffix>
                                <span>
                                    {{ dataQuote.transportation ? (dataQuote.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                                </span>
                            </template>
                        </hts-form-input>
                        <hts-form-input
                            v-model="dataQuote.weightCommodity"
                            :label="$t('labels.weightCommodityByKG1')"
                            type="number"
                            readonly
                            prop="weightCommodityByKG"
                            name="weightCommodityByKG1">
                            <template #suffix>
                                <span>
                                    {{ dataQuote.transportation ? (dataQuote.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                                </span>
                            </template>
                        </hts-form-input>
                        <hts-form-textarea
                            v-model="dataQuote.request"
                            :label="$t('labels.requestOther')"
                            readonly />
                    </div>
                </hts-card>
                <workflow-position ref="workflowPosition" />
                <view-position
                    ref="viewPosition"
                    :edit="false" />
            </div>
            <div v-if="tab === 'quote-internal'">
                <div v-if="priceDetail">
                    <price-information
                        :p-price-detail="priceDetail"
                        :p-price-offline-fee="dataQuote.priceOfflineFee" />
                </div>
                <div
                    v-else
                    class="text-center italic text-lg">
                    Không tìm thấy giá nội bộ
                </div>
            </div>
        </div>

        <routing-connection
            ref="routingConnection"
            :edit="false" />
    </hts-router-drawer>
</template>

<script lang="ts" setup>
import { addQuote } from '../../-components/ignore/imports/form'

import DataTablePrice from '../-components/data-table-price.vue'
import ViewInformation from '../../-components/information.vue'
import PriceInformation from '../../-components/price-information.vue'
import ViewQuotePrice from '../../-components/view-quote-price.vue'
import RoutingConnection from '../../quote-request/-components/routing-connection.vue'
import ViewPosition from '../../quote-request/-components/view-position.vue'
import WorkflowPosition from '../../quote-request/-components/workflow-position.vue'
import layoutPermissions from '~/data/permissions/layout-permissions'
import pageTabs from '~/data/page-tabs/trucker.json'
import { checkPermission } from '@/utils/permission-check'
import { $downloadjs } from '#imports'

import screen from '~/components/utils/screen'

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 100}px`
})

const routingConnection = ref()
const routingConnectionsData = ref<{ [key: string]: any }[][]>([])
const emits = defineEmits(['refreshTables'])

const tab = ref('')

const loading = ref(false)
const quoteId = computed(() => useRoute().params.idquote)
const dataQuote = ref<addQuote>({
  informationEditorPricingSelling: {
    pricingRequest: null,
    tempPricingRequest: null,
    commission: null,
    duration: null,
    priceIncrementLevel: null
  },
  workflow: '',
  positions: [],
  transportation: '',
  mergeContainer: false,
  headContainer: false,
  priceOfflineFee: [],
  customerName: '',
  customer: '',
  contact: '',
  contactName: '',
  contactPhone: '',
  contactEmail: '',
  policy: {
    freeHourNumber: 0,
    moocKeepHourly: 0,
    moocKeepOvernight: 0,
    calculatedByHourNextDay: '',
    moocKeepLongTerm: 0,
    calculatedFromEvening: 0,
    towingContainerSunday: 0,
    towingContainerHoliday: 0,
    reeferPluginChargesGenerator: 0
  },
  customerService: {
    id: '',
    name: '',
    phone: ''
  },
  abstemious: {
    id: '',
    name: '',
    phone: ''
  },
  groupEmail: '',
  compensationCost: null,
  exceptCompensationCost: '',
  charges: [],
  cooperatorDetail: null,
  contactDetail: null,
  dataConfig: {
    duration: 0,
    commission: 0,
    markup: 0,
    corporateIncomeTax: 0,
    monthlyInterest: 0,
    priceGasOline: 0,
    incrementLevel: 0
  },
  status: 0,
  quoteTempSaveId: '',
  effectiveFromDate: '',
  effectiveToDate: '',
  minMarkupConfirm: null,
  statusApprovalMarkup: null,
  markupAvailable: false
})
const route = useRoute()
onBeforeMount(() => {
  route.meta.pageTabs = pageTabs?.quote || []
})

const dataTablePrice = ref()

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}
const getData = () => {
  loading.value = true
  const api = $url.quote.detail
  $api(api, { uriParams: { ID: quoteId.value } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataQuote.value, { ...resData.data })
        dataQuote.value.contName = dataQuote.value.contCategory ? listLabelCont[dataQuote.value.contCategory] : ''
        dataTablePrice.value && dataTablePrice.value.refresh()

        routingConnectionsData.value = $lodash.cloneDeep(dataQuote.value?.quoteTempSave?.quoteRequestData?.routingConnections)
        if (dataQuote.value?.quoteTempSave?.quoteRequestData?.routingConnections) {
          dataQuote.value.quoteTempSave.quoteRequestData.routingConnections = dataQuote.value.quoteTempSave?.quoteRequestData?.routingConnections.map(
            (item: any) => {
              const pluckIdData = $lodash.map(item, 'node')
              const nodeIds = $lodash.join(pluckIdData, '-')
              return nodeIds
            }
          )
        }
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}
const loadingDownLoadXlsx = ref(false)
const loadingSendEmail = ref(false)

const CDisabled = computed(() => {
  return (!dataQuote.value.markupAvailable && dataQuote.value.statusApprovalMarkup === 1) || dataQuote.value.statusApprovalMarkup === 2
})
const downloadQuoteXlsx = () => {
  loadingDownLoadXlsx.value = true
  const api = $url.quote.xlsx
  $api(api, { uriParams: { ID: quoteId.value }, contentType: 'blob' })
    .then((data: any) => {
      const resData: any = data.data.value
      const fileName = resData.headers.get('filename') || 'Quote.xlsx'
      const contentType = resData.headers.get('Content-type')
      $downloadjs(resData, fileName, contentType)
      loadingDownLoadXlsx.value = false
    })
    .catch(() => {
      loadingDownLoadXlsx.value = false
      process.client && $toast().error($t('labels.canNotConnectServer'))
    })
}

const refreshTables = () => {
  emits('refreshTables')
}

const sendEmail = async () => {
  loadingSendEmail.value = true
  const api = $url.quote.sendEmail
  const data: any = await $api(api, { uriParams: { ID: quoteId.value }, contentType: 'blob' })
  const resData: any = data.data.value
  if (resData?.success) {
    emits('refreshTables')
    process.client && $toast().success($t('labels.sendEmailCustomerSuccessfully'))
  }
  loadingSendEmail.value = false
}

const loadingDownLoadPdf = ref(false)
const downloadQuotePdf = () => {
  loadingDownLoadPdf.value = true
  const api = $url.quote.pdf
  $api(api, { uriParams: { ID: quoteId.value }, contentType: 'blob' })
    .then((data: any) => {
      const resData: any = data.data.value
      const fileName = resData.headers.get('filename') || 'Quote.pdf'
      const contentType = resData.headers.get('Content-type')
      $downloadjs(resData, fileName, contentType)
      loadingDownLoadPdf.value = false
    })
    .catch(() => {
      loadingDownLoadPdf.value = false
      process.client && $toast().error($t('labels.canNotConnectServer'))
    })
}
const workflowPosition = ref()
const openWorkflowPosition = (position: Array<{ [key: string]: any }>) => {
  if (workflowPosition.value) {
    workflowPosition.value.open($lodash.cloneDeep(position), dataQuote.value, true)
  }
}

const viewPosition = ref()
const openWithMap = () => {
  viewPosition.value &&
    viewPosition.value.open({
      positions: dataQuote.value.positions,
      routingPositionsData: dataQuote.value?.quoteTempSave?.quoteRequestData?.routingPositions,
      routingConnectionsData: routingConnectionsData.value || [],
      routingPositionsConnections: dataQuote.value?.quoteTempSave?.quoteRequestData?.routingPositionsConnections
    })
}

const priceDetail = computed(() => {
  return dataQuote.value.charges.find((charge) => {
    return charge.type === 'internal' && charge.isMain
  })
})

const handleFindRoutingConnection = () => {
  if (routingConnection.value) {
    routingConnection.value.open(
      dataQuote.value.positions || [],
      dataQuote.value?.quoteTempSave?.quoteRequestData?.routingConnections,
      dataQuote.value?.quoteTempSave?.quoteRequestData?.connectingPositions || []
    )
  }
}

const tabs = [
  {
    key: 'quote',
    label: $t('labels.quote'),
    permission: checkPermission(layoutPermissions.quote_view_detail)
  },
  { key: 'quote-request', label: $t('labels.quoteRequest'), permission: checkPermission(layoutPermissions.quote_view_detail_quote_request) },
  {
    key: 'quote-price-information',
    label: $t('labels.priceInformation'),
    permission: checkPermission(layoutPermissions.quote_price_information),
    active: true
  },
  { key: 'quote-internal', label: $t('labels.quoteInternal'), permission: checkPermission(layoutPermissions.quote_view_detail_quote_internal) }
]
</script>
